import { memoize } from 'lodash/function';
import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import request from 'functions/api/request';

export const getProfileTitles = memoize(
  async (condition) => {
    const requestOptions = {
      url: `${configs.beApiUrl}/public/profileTitles/${condition}`,
      headers: {
        ...await authHeaders(),
      },
    };

    try {
      return await request.get(requestOptions);
    } catch (ex) {
      console.error('getting profileTitles error', ex);
      return null;
    }
  },
  (condition) => condition,
);
